import { Palette } from "@material-ui/core/styles/createPalette";
import { createTheme, ThemeOptions } from "@material-ui/core";
import { lightGreen, indigo } from "@material-ui/core/colors";

interface ColorTypes {
	primary: {
		main: string;
		dark: string;
		light: string;
		contrastText: string;
	};
	secondary: {
		main: string;
		dark: string;
		light: string;
		contrastText: string;
	};
	warning: {
		main: string;
		dark: string;
		light: string;
		contrastText: string;
	};
	error: {
		main: string;
		dark: string;
		light: string;
		contrastText: string;
	};
	highlighted: string;
	background: {
		default: string;
	};
}

export interface LyfePalette extends Palette {
	platform: ColorTypes;
}

interface LyfeThemeOptions extends ThemeOptions {
	palette: LyfePalette;
}

export const lyfeTheme = createTheme({
	palette: {
		platform: {
			primary: {
				main: "#37679D",
				dark: "#27486E",
				light: "#B2D3F2",
				contrastText: "#fff",
			},
			secondary: {
				main: "#00A870",
				light: lightGreen[100],
				dark: lightGreen[900],
				contrastText: "#fff",
			},
			warning: {
				main: "#F28222",
				dark: "#a95b17",
				light: "#ffe4bd",
				contrastText: "#fff",
			},
			error: {
				main: "#f6685e",
				dark: "#aa2e25",
				light: "#f2aeae",
				contrastText: "#fff",
			},
			background: {
				default: "#CCE4FF",
			},
		},
		primary: {
			main: "#0101E9",
			dark: "#0000a3",
			light: indigo[100],
		},
		secondary: {
			main: "#00A870",
			light: lightGreen[100],
			dark: lightGreen[900],
		},
		warning: {
			main: "#F28222",
			dark: "#a95b17",
			light: "#ffe4bd",
		},
		grey: {
			"500": "#646666",
		},
		background: {
			default: "#F4F7F9",
		},
	},
	typography: {
		fontFamily: ["IBM Plex Sans", "Helvetica Neue", "Arial"].join(","),
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		fontWeightBold: 700,
	},
	overrides: {
		MuiTableCell: {
			footer: {
				color: "rgba(255, 255, 255, 0.7)",
				fontSize: "0.75rem",
				lineHeight: "1.3125rem",
				borderBottom: "0px",
			},
		},
	},
} as LyfeThemeOptions);
